<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem wide-label">
          <div class="label" style="width: 150px; white-space: nowrap;">采购人/统一信用代码</div>
          <div class="field">
            <el-input v-model.trim="query.keyword" clearable @keyup.enter.native="search"></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>

    <vggrid :list="list" tableheight="640" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total" :isOperate="true"
            :operateBtn="operateBtn" @vggridClick="vggridClick"
            @pagechange="pagechange">
    </vggrid>

    <blacklist-dialog :visible.sync="dialogVisible" :comid="curCom.comid" :comname="curCom.comname"></blacklist-dialog>
  </Container>
</template>

<script>
  import vggrid from '../common/vggrid'
  import blacklistDialog from './blacklistDialog'
  import { getRelComList } from '@/api/usercomrel'

  export default {
    name: 'blacklistIndex',
    data () {
      return {
        list: [],
        cols: [
          { type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80 },
          { field: 'comfullname', fieldtype: 'C', title: '采购人', calculExpr: '', addNewRowFlg: false },
          { field: 'comidcode', fieldtype: 'C', title: '统一信用代码', calculExpr: '', addNewRowFlg: false }
        ],
        operateBtn: [
          { btncode: 'BLACKLIST', btnname: '黑名单', btnicon: 'el-icon-s-order', btntext: '黑名单', btnstatus: 'primary', btntype: 'text', btnsize: 'mini', btncircle: false }
        ],
        dialogVisible: false,
        curCom: { comid: 0, comname: '' },
        query: {
          keyword: '',
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    activated () {
      this.getPageList()
    },
    components: {vggrid, blacklistDialog},
    methods: {
      vggridClick (code, row) {
        if (code === 'BLACKLIST') {
          this.curCom = { comid: row.comid, comname: row.comfullname }
          this.dialogVisible = true
        }
      },
      async pagechange (userPage) {
        this.query.offset = userPage.pageSize * (userPage.currentPage - 1)
        this.query.limit = userPage.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      // 当前登录用户已关联的采购人公司列表
      async getPageList () {
        this.loading = true
        let all = await getRelComList({ userid: this.$store.getters.loginUser.userid })
        let list = all || []
        if (this.query.keyword) {
          let kw = this.query.keyword
          list = list.filter(c => (c.comfullname || '').indexOf(kw) !== -1 || (c.comidcode || '').indexOf(kw) !== -1)
        }
        this.query.total = list.length
        // 前端分页（接口一次性返回全部关联采购人，数量通常不大）
        this.list = list.slice(this.query.offset, this.query.offset + this.query.limit)
        this.loading = false
      }
    }
  }
</script>

<style lang="scss">
</style>
